import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
// eslint-disable-next-line react/display-name
const Tooltip = /*#__PURE__*/ React.forwardRef(({ placement = 'right', className, style, children, arrowProps, // eslint-disable-next-line @typescript-eslint/no-unused-vars
popper: _, // eslint-disable-next-line @typescript-eslint/no-unused-vars
show: _2, ...props }, ref)=>{
    let [primaryPlacement] = placement?.split('-') || [];
    if (primaryPlacement === 'left') {
        primaryPlacement = 'start';
    } else if (primaryPlacement === 'right') {
        primaryPlacement = 'end';
    }
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        style: style,
        role: "tooltip",
        className: classNames(className, 'tooltip', `bs-tooltip-${primaryPlacement}`),
        ...props,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tooltip-inner",
                children: children
            })
        ]
    });
});
Tooltip.displayName = 'Tooltip';
Tooltip.DEFAULT_OFFSET = [
    0,
    8
];
export { Tooltip };
